// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen {
  app-contact-image-displayer {
    width: 64px;
    min-height: 64px;
    width: 3rem;
    height: 3rem;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .business .contact-type-icon {
    float: left;
    color: #ccc;
  }
  .business .contact-type-icon:after {
    content: "\\e7fb";
    font-family: "icomoon";
  }
  .business .contact-type-icon {
    padding-right: 10px;
  }
  .inactive-contact {
    opacity: 0.5;
  }
}
.company-code.more ion-icon {
  font-size: 1.5em;
  color: var(--ion-color-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/contact-list-item/contact-list-item.component.scss"],"names":[],"mappings":"AAAA;EACC;IACC,WAAA;IACA,gBAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IAEA,aAAA;IAEA,mBAAA;IAEA,uBAAA;EACA;EAED;IACC,WAAA;IACA,WAAA;EAAA;EACA;IACC,gBAAA;IACA,sBAAA;EACD;EAND;IAOC,mBAAA;EAEA;EACE;IACI,YAAA;EACN;AACF;AAGC;EACC,gBAAA;EACA,4BAAA;AADF","sourcesContent":["@media only screen {\r\n\tapp-contact-image-displayer {\r\n\t\twidth: 64px;\r\n\t\tmin-height: 64px;\r\n\t\twidth: 3rem;\r\n\t\theight: 3rem;\r\n\t\tfloat: left;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\t-ms-flex-pack: center;\r\n\t\tjustify-content: center;\r\n\t}\r\n\r\n\t.business .contact-type-icon {\r\n\t\tfloat: left;\r\n\t\tcolor: #ccc;\r\n\t\t&:after {\r\n\t\t\tcontent: \"\\e7fb\";\r\n\t\t\tfont-family: \"icomoon\";\r\n\t\t}\r\n\t\tpadding-right: 10px;\r\n\t}\r\n\r\n    .inactive-contact {\r\n        opacity: 0.5;\r\n    }\r\n}\r\n\r\n.company-code.more {\r\n\tion-icon {\r\n\t\tfont-size: 1.5em;\r\n\t\tcolor: var(--ion-color-dark);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
